import {getGlobal} from "reactn";
import {P, SelectItem} from "oca-lib-web";
import AppStoreConnectDataAccess from "./AppStoreConnectDataAccess";
import FlurryDataAccess from "./FlurryDataAccess";
import GoogleAnalyticsDataAccess from "./GoogleAnalyticsDataAccess";
import AppReviewDataAccess from "./AppReviewDataAccess";
import TwitterDataAccess from "./TwitterDataAccess";

export default class BaseDataSource {

    public static async loadData(project:ProjectModel, timeInterval:TimeInterval):Promise<any> {
        console.log("--- LOADING DATA FOR " + project.projectName + " ---");
        let dataLoadPromises = [];
        this.clearData();

        let dataSources = await getGlobal().dataManager.get("getDataSources", project.id);
        console.log(dataSources);
        for (let dataSource of dataSources) {
            if (dataSource.params) {
                let params = JSON.parse(dataSource.params);
                if (params.disabled) {
                    console.log("SKIPPING: " + params.dataSource);
                    continue;
                }
                if (params.dataSource == "appstore") {
                    dataLoadPromises.push(getGlobal().appstore.fetchData(dataSource.id, timeInterval));
                    //dataLoadPromises.push(getGlobal().appreviews.fetchData(dataSource, timeInterval));
                } else if (params.dataSource == "googleplay") {
                    dataLoadPromises.push(getGlobal().googleplay.fetchData(dataSource.id, timeInterval));
                } else if (params.dataSource == "flurry") {
                    //dataLoadPromises.push(getGlobal().flurry.fetchData(dataSource, timeInterval));
                    dataLoadPromises.push(getGlobal().flurry.fetchUsage(timeInterval, dataSource));
                    dataLoadPromises.push(getGlobal().flurry.fetchEventParams(timeInterval, dataSource));
                } else if (params.dataSource == "googleanalytics") {
                    dataLoadPromises.push(getGlobal().googleanalytics.fetchData(dataSource.id, timeInterval));
                } else if (params.dataSource == "twitter") {
                    dataLoadPromises.push(getGlobal().twitter.fetchData(dataSource.id, timeInterval));
                } else if (params.dataSource == "custom") {
                    dataLoadPromises.push(getGlobal().customdata.fetchData(dataSource, timeInterval));
                }
            }
        }
        await Promise.all(dataLoadPromises);
        return P.resolve(true);
    }

    public static clearDataCache(project:ProjectModel):Promise<any> {
        console.log("clearDataCache");
        return new Promise<boolean>(async function(resolve) {
            let dataSources = await getGlobal().dataManager.get("getDataSources", project.id);
            for (let dataSource of dataSources) {
                if (dataSource.params) {
                    let params = JSON.parse(dataSource.params);
                    if (params.dataSource == "appstore") {
                        getGlobal().appstore.clearCache();
                    } else if (params.dataSource == "googleplay") {
                        getGlobal().googleplay.clearCache();
                    } else if (params.dataSource == "flurry") {
                        getGlobal().flurry.clearUsageCache();
                        getGlobal().flurry.clearEventParamCache();
                    } else if (params.dataSource == "googleanalytics") {

                    } else if (params.dataSource == "twitter") {

                    } else if (params.dataSource == "custom") {

                    }
                }
            }
            resolve(true);
        });
    }

    public static async getAvailableDatasets(projectId:string) {
        let self = this;
        let datasets:Array<{value:any, label:string}> = [];
        let dataSources = await getGlobal().dataManager.get("getDataSources", projectId);
        return new Promise<any>(function(resolve) {
            for (let dataSource of dataSources) {
                if (dataSource.params) {
                    let params = JSON.parse(dataSource.params);
                    if (params.dataSource == "appstore" || params.dataSource == "googleplay") {
                        if (!self.doesDatasetExist(datasets, AppStoreConnectDataAccess.APPDOWNLOADS)) {
                            datasets.push(SelectItem.create(AppStoreConnectDataAccess.APPDOWNLOADS, "App Stores"));
                        }
                        if (!self.doesDatasetExist(datasets, AppReviewDataAccess.APPREVIEWS)) {
                            datasets.push(SelectItem.create(AppReviewDataAccess.APPREVIEWS, "App Reviews"));
                        }

                    } else if (params.dataSource == "flurry") {
                        datasets.push(SelectItem.create(FlurryDataAccess.APPUSAGE, "Flurry - App Usage"));
                        datasets.push(SelectItem.create(FlurryDataAccess.EVENTPARAMS, "Flurry - Event Params"));

                    } else if (params.dataSource == "googleanalytics") {
                        datasets.push(SelectItem.create(GoogleAnalyticsDataAccess.PAGEVIEWS, "Google Analytics - Page Views"))
                        datasets.push(SelectItem.create(GoogleAnalyticsDataAccess.TRAFFICSOURCES, "Google Analytics - Traffic Sources"))
                        datasets.push(SelectItem.create(GoogleAnalyticsDataAccess.USERSESSIONS, "Google Analytics - User Sessions"))

                    } else if (params.dataSource == "twitter") {
                        datasets.push(SelectItem.create(TwitterDataAccess.TWITTER, "Social Media - Twitter"))

                    } else if (params.dataSource == "custom") {
                        datasets.push(SelectItem.create(dataSource.id, params.dataSourceName));
                    }
                }
            }
            resolve(datasets);
        })
    }

    public static getDataForDataSource(dataSource:string):Array<any> {
        let data:Array<any> = [];
        if (dataSource == AppStoreConnectDataAccess.APPDOWNLOADS) {
            data = [...getGlobal().appstore.data, ...getGlobal().googleplay.data]
        } else if (dataSource == FlurryDataAccess.APPUSAGE) {
            data = getGlobal().flurry.usage;
        } else if (dataSource == FlurryDataAccess.EVENTPARAMS) {
            data = getGlobal().flurry.eventParams;
        } else if (dataSource == GoogleAnalyticsDataAccess.USERSESSIONS) {
            data = getGlobal().googleanalytics.userSessions;
        } else if (dataSource == GoogleAnalyticsDataAccess.TRAFFICSOURCES) {
            data = getGlobal().googleanalytics.trafficSources;
        } else if (dataSource == GoogleAnalyticsDataAccess.PAGEVIEWS) {
            data = getGlobal().googleanalytics.pageViews;
        } else if (dataSource == TwitterDataAccess.TWITTER) {
            data = getGlobal().twitter.data;
        } else {
            data = getGlobal().customdata.getResults(dataSource);
            //console.log(dataset);
        }
        return data;
    }

    private static doesDatasetExist(datasets:Array<any>, key:string) {
        let exists = false;
        for (let dataset of datasets) {
            if (dataset.value == key) {
                exists = true;
            }
        }
        return exists;
    }

    public static clearData() {
        getGlobal().flurry.clearData();
        getGlobal().appstore.clearData();
        getGlobal().googleplay.clearData();
        getGlobal().googleanalytics.clearData();
        getGlobal().customdata.clearData();
    }
}